module.exports = __webpack_public_path__ + "static/contentBlockAlternative-4ff612ba171f1ce794bc5d3104fe1ba6.png";